export default __webpack_public_path__ + "static/media/tiffi.46da4cca.jpg";